import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "./useAppContext";
import { useEditor } from "./useEditor";
import { useMessageToState } from "./useMessageToState";

const getRowId = (editor: eXpress.core.IEditor) => editor.commandManager.getRowId();

function useDefinitionRowId() {
	return useMessageToState({
		name: "useDefinitionRowId",
		getState: getRowId,
	});
}

export function useProductErrorsAndWarnings() {
	const editor = useEditor();
	const { getFontSizeCorrectorAsync } = useAppContext();
	const rowId = useDefinitionRowId();

	const result = useQuery({
		queryKey: ["use-product-errors-and-warnings", rowId, getFontSizeCorrectorAsync],
		queryFn: async () => {
			return (
				await editor.validateAsync({
					getFontSizeCorrectorAsync,
					getLocalizedMonthNames: undefined,
				})
			).filter(
				(m) =>
					m.name === "BadQualityPhotoZones" ||
					m.name === "RejectedPhotosNotAllowed" ||
					m.name === "BadQualityTextZones" ||
					m.name === "TextOutsideBounds",
			);
		},
		retry: false,
	});

	return {
		productErrorsAndWarnings: result.data ?? [],
		productErrorsAndWarningsLoading: result.isFetching,
		hasProductErrorsOrWarnings: !!result?.data?.length,
	};
}
